import React from "react";
import { useAppSelector } from "../../redux/hooks";
import { USER_GROUP } from "../../config/constant";
import ReportContractAgent from "./ReportContractAgent";
import ReportContractCompany from "./ReportContractCompany";

const ReportContract = () => {
  const accountDetail = useAppSelector((state) => state.authAccount?.user);
  if (accountDetail?.group === USER_GROUP.CAR_COMPANY) {
    return <ReportContractCompany />;
  }
  if (accountDetail?.group === USER_GROUP.AGENT) {
    return <ReportContractAgent />;
  }
  return <></>;
};

export default ReportContract;
